import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/Main'
import { Button, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import InputWrapper from 'shared/components/InputWrapper'
import resEditEmailTemplate from './resolvers/resEditEmailTemplate'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import BackButton from 'shared/components/BackButton'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import * as Icon from 'react-bootstrap-icons'

const submitRef = React.createRef<HTMLButtonElement>()

const EditEmailTemplate: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})
  const [body, setBody] = useState<string>('')

  const [bodyLabel] = useState<any>(
    <OverlayTrigger
      placement='right'
      delay={{ show: 100, hide: 300 }}
      overlay={
        <Tooltip className='tooltip-wide'>
          <>
            <Row className='text-start ps-4'>
              <Col sm={12}>Use following subsitute words:</Col>
              <Col sm={12}>
                <code>@@customerName@@</code> Customer Name
              </Col>
              <Col sm={12}>
                <code>@@homeUrl@@</code> Home URL
              </Col>
              <Col sm={12}>
                <code>@@fullName@@</code> Full Name
              </Col>
               <Col sm={12}>
                <code>@@email@@</code> Email
              </Col>
              <Col sm={12}>
                <code>@@password@@</code> Password
              </Col>
            </Row>
          </>
        </Tooltip>
      }
    >
      <span style={{ cursor: 'help' }}>
        Body <Icon.QuestionCircleFill />
      </span>
    </OverlayTrigger>,
  )

  const { id } = useParams()

  const navigate = useNavigate()

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setValue,
    setFocus,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resEditEmailTemplate,
  })

  useInit({
    getValues,
    id,
    reset,
    setDataLoaded,
    setShowOverlay,
    currentCustomer,
    setBody
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      headerInsert={
        <BackButton url='/email-templates' text='All Email Templates' />
      }
      actionInsert={
        <Button
          disabled={!dataLoaded}
          type='submit'
          name='save'
          className='btn-round btn-primary'
          onClick={() => {
            if (submitRef.current != null) {
              submitRef.current.click()
            }
          }}
        >
          Save Template
        </Button>
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data,
            setShowOverlay,
            setError,
            id,
            name: 'Email Templates',
            successNav: '/email-templates',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='Name' name='name' errors={errors}>
          <Form.Control type='text' {...register('name')} />
        </InputWrapper>
        
        <InputWrapper label='Subject' name='subject' errors={errors}>
          <Form.Control type='text' {...register('subject')} />
        </InputWrapper>
        
        <InputWrapper label='Sender Email' name='sender_email' errors={errors}>
          <Form.Control type='text' {...register('sender_email')} />
        </InputWrapper>
        
        <InputWrapper label='Sender Name' name='sender_name' errors={errors}>
          <Form.Control type='text' {...register('sender_name')} />
        </InputWrapper>

        
        <InputWrapper
            label={bodyLabel}
            name='body'
            errors={errors}
            colAttributes={{ md: 12 }}
          >
            <CKEditor
              editor={Editor}
              data={body}
              onChange={(event: any, editor: any) => {
                const data = editor.getData()
                setBody(data)
                setValue('body', data)
              }}
            />
          </InputWrapper>


        <Button
          type='submit'
          name='save'
          ref={submitRef}
          className='d-none'
        ></Button>
      </Form>
    </Layout>
  )
}

export default EditEmailTemplate
